<template>
  <div id="user-statistics-statistics">
    <Breadcrumbs
      v-if="!isChildComponent"
      :breadcrumbs="breadcrumbs">
      <div slot="breadcrumbAfter" class="d-flex align-items-center">
        <va-popover
          v-if="isSupervisor"
          class="ml-2"
          placement="left"
          :message="$t('statistics2.ops_stats.downloadExcel')">
          <span class="icon i-cloud-download" @click.prevent="showDownloadExcelModal=true"></span>
        </va-popover>
      </div>
    </Breadcrumbs>

    <section class="filters row evollu-form">

      <div class="col-12 col-md-3">
        <range-date-picker
          id="statistics-date-range"
          :label="$t('clinical.waiting_room_statistics.date_range')"
          v-model="filters.dateRange"
          placeholder="---"
          :config="rangeDatePickerConfig"
          :clearable="false"
        >
        </range-date-picker>
      </div>

      <div class="col-12 col-md-3" v-if="entityOptions.length > 1">
        <label class="form-label">
          {{ $t('clinical.waiting_room_statistics.entity') }}
        </label>
        <multiselect
          id="entities-filter"
          v-model="filters.entities"
          :options="entityOptions"
          track-by="uid"
          :customLabel="formatedEntityLabel"
          :placeholder="entityOptions.length ? $t('clinical.waiting_room_statistics.all_entities') : $t('clinical.waiting_room_statistics.no_entities')"
          :allow-empty="true"
          :multiple="true"
          :disabled="!entityOptions.length || isRequestingData"
        >

          <template slot="clear">
            <span class="multiselect__clear" v-if="filters.entities.length" @mousedown.prevent.stop="filters.entities = []"></span>
          </template>
        </multiselect>
      </div>

      <div class="col-12 col-md-3" v-if="userHasReadDispenserStatisticsPermissions">
        <label class="form-label">
          {{ $t('clinical.waiting_room_statistics.collaborators') }}
        </label>
        <multiselect
          id="collaborators-filter"
          v-model="filters.dispensers"
          :options="userOptions"
          track-by="id"
          :customLabel="formatedUserLabel"
          :placeholder="userOptions.length ? $t('clinical.waiting_room_statistics.all_collaborators') : $t('clinical.waiting_room_statistics.no_collaborators')"
          :allow-empty="true"
          :multiple="true"
          :disabled="!userOptions.length || isRequestingData"
        >

          <template slot="clear">
            <span class="multiselect__clear" v-if="filters.dispensers.length > 0" @mousedown.prevent.stop="filters.dispensers = []"></span>
          </template>
        </multiselect>
      </div>

      <div class="col-12 col-md-3" v-if="isSupervisor">
        <label class="form-label">
          {{ $t('clinical.appointments.type') }}
        </label>
        <multiselect
          id="appt-type-filter"
          v-model="filters.appointmentTypes"
          :options="appointmentTypesOptions"
          track-by="id"
          label="type"
          placeholder="---"
          :allow-empty="true"
          :multiple="true"
          :close-on-select="false"
        >

          <template slot="clear">
            <span class="multiselect__clear" v-if="filters.appointmentTypes.length > 0" @mousedown.prevent.stop="filters.appointmentTypes = []"></span>
          </template>
        </multiselect>
      </div>
    </section>

    <fade-transition :duration="200" mode="out-in">
      <section v-if="isLoading" class="text-center py-5">
        <span class="is-bold">{{$t('loading.message')}}</span>
      </section>

      <section v-else class="dispenser-center-statistics" key="dispenser-center-statistics">

        <div class="py-4">
          <div class="row px-2 mb-5">

            <KPICard
              class="col-12 col-sm-6 col-md-4 col-lg-3 offset-lg-1 mb-5"
              :title="originalData.requests"
              :subtitle="$t('virtual_waiting_room.statistics.requests_finished')"
            />

            <KPICard
              class="col-12 col-sm-6 col-md-4 col-lg-3 offset-lg-1 mb-5"
              :title="originalData.canceled_requests"
              :subtitle="$t('virtual_waiting_room.statistics.requests_canceled')"
            />


            <!--<KPICard
              class="col-12 col-sm-6 col-md-4 col-lg-3 offset-lg-1 mb-5"
              :title="getRelativeTimeString(originalData.avg_request_duration)"
              :subtitle="$t('clinical.waiting_room_statistics.average_call_request_duration')"
            >
              <template slot="title">
                <h3 class="card__container__main__title py-1" v-if="originalData.avg_request_duration < 3600">
                  {{getRelativeTimeString(originalData.avg_request_duration)}}
                </h3>

                <h4 class="card__container__main__title py-2" v-else>
                  {{getRelativeTimeString(originalData.avg_request_duration)}}
                </h4>
              </template>
            </KPICard>-->

            <KPICard
              class="col-12 col-sm-6 col-md-4 col-lg-3 offset-lg-1 mb-5"
              :title="getRelativeTimeString(originalData.avg_request_waiting_time)"
              :subtitle="$t('clinical.waiting_room_statistics.average_call_request_waiting_time')"
            >
              <template slot="title">
                <h3 class="card__container__main__title py-1" v-if="originalData.avg_request_waiting_time < 3600">
                  {{getRelativeTimeString(originalData.avg_request_waiting_time)}}
                </h3>

                <h4 class="card__container__main__title py-2" v-else>
                  {{getRelativeTimeString(originalData.avg_request_waiting_time)}}
                </h4>
              </template>
            </KPICard>

            <!-- Avaliações desativadas temporariamente (manter página de avaliações de consultas)
            <KPICard
              class="col-12 col-sm-6 col-md-4 col-lg-3 mb-5"
              :title="originalData.avg_dispenser_rating.toFixed(2)"
              :subtitle="$t('clinical.waiting_room_statistics.users.average_dispenser_rating')"
            />

            <KPICard
              class="col-12 col-sm-6 col-md-4 col-lg-3 offset-lg-1 mb-5"
              :title="originalData.avg_audiologist_rating.toFixed(2)"
              :subtitle="$t('clinical.waiting_room_statistics.users.average_audiologist_rating')"
            />
            -->
          </div>
        </div>
      </section>

    </fade-transition>

    <DownloadExcelModal
      exportType="dispensers"
      v-if="showDownloadExcelModal"
      @modalClosed="exportExcelClosed"
    />

  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { get as _get } from 'lodash'
import Multiselect from 'vue-multiselect'
import { HollowDotsSpinner } from 'epic-spinners'
import KPICard from '@/components/common/KPICard'
import { ActivityService } from '@/api/AuthService'
import Breadcrumbs from '@/components/common/Breadcrumbs'
import RelativeTimeMixin from '@/mixins/RelativeTimeMixin'
import { StatisticsService } from '@/api/VirtualWaitingRoomService'
import RangeDatePicker from '@/components/common/RangeDatePicker'
import { WAITING_ROOM_DISPENSER_STATISTICS } from '@/local-storage/LocalStorageKeys'
import LocalStorageHelper from '@/local-storage/LocalStorageHelper'
import FadeTransition from '@/components/common/transitions/FadeTransition'
import MultiselectLabelFormatter from '@/mixins/MultiselectLabelFormatter'
import ClustersAndEntitiesMixin from '@/mixins/ClustersAndEntitiesMixin'
import DownloadExcelModal from '@/components/virtual_waiting_room/statistics/DownloadExcelModal.vue';

const DispenserFieldActivityId = 8
const DispenserOnPremisesActivityId = 9
const WriteAccessType = 2
const DispenserStatisticsInfoType = 800

export default {
  props: {
    component: {
      type: Object,
      required: true
    },
    serviceSlug: {
      type: String,
      required: true
    },
    isChildComponent: {
      type: Boolean,
      default: false
    }
  },
  components: {
    DownloadExcelModal,
    KPICard,
    Breadcrumbs,
    Multiselect,
    FadeTransition,
    RangeDatePicker,
    HollowDotsSpinner
  },
  mixins: [
    RelativeTimeMixin,
    ClustersAndEntitiesMixin,
    MultiselectLabelFormatter,
  ],
  computed: {
    ...mapGetters([
      'clusters'
    ]),
    ...mapGetters('auth', [
      'authUserEntityActivities'
    ]),
    ...mapState('auth', [
      'hasLoadedAuthUserEntityActivities'
    ]),
    ...mapState({
      appointmentTypesOptions: function(state) {
        return state[this.waitingRoomModuleKey].appointmentTypes
      }
    }),
    breadcrumbs: function () {
      return [
        { title: this.$t(`menu.${this.serviceSlug}`), disabled: true },
        { title: this.$t('menu.clinical/statistics/waitingroom/dispensers'), active: true },
      ]
    },
    readDispenserStatisticsPermissions: function () {
      return this.component.service.user_permissions.filter(p => p.access_type >= WriteAccessType && p.info_type === DispenserStatisticsInfoType)
    },
    readStatisticsEntities: function () {
      if (this.component.service !== null) {
        if (this.readDispenserStatisticsPermissions.length > 0) {
          if (this.readDispenserStatisticsPermissions.some(p => p.entity_id === null)) {
            return [...this.component.service.entities]
          } else {
            return this.component.service.entities.filter(entity => this.readDispenserStatisticsPermissions.some(p => p.entity_id === entity.id))
          }
        } else {
          return []
        }
      }
    },
    userHasReadDispenserStatisticsPermissions: function () {
      return this.readDispenserStatisticsPermissions.length > 0
    },
    rangeDatePickerConfig: function () {
      return this.userHasReadDispenserStatisticsPermissions ? {} : { maxInterval: { value: 6, unit: 'months' } }
    },
    usersFromEntityActivities: function () {
      let users = {}

      this.entityActivityRecordsForPeriod.forEach(entityActivityRecord => {
        if (entityActivityRecord.user !== null) {
          let entry = users[entityActivityRecord.user.id]

          if (!users.hasOwnProperty(entityActivityRecord.user.id)) {
            entry = {
              id: entityActivityRecord.user.id,
              name: entityActivityRecord.user.name,
              nickname: entityActivityRecord.user.nickname,
              entity: this.component.service.entities.find(entity => entity.id === entityActivityRecord.user.entity_id) || null,
              activities: []
            }
            users[entityActivityRecord.user.id] = entry
          }

          entry.activities.push({
            entity_id: entityActivityRecord.entity.id,
            activity_id: entityActivityRecord.activity.id
          })
        }
      })
      users = Object.values(users)

      users.sort((a, b) => {
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
      })
      return Object.values(users)
    },
    readableEntities: function () {
      let entities = [...this.readStatisticsEntities]

      if (this.authUserEntityActivities.length) {
        this.authUserEntityActivities.forEach(entityActivityRecord => {
          if (!entities.some(entity => entity.id === entityActivityRecord.entity.id)) {
            entities.push({
              id: entityActivityRecord.entity.id,
              name: entityActivityRecord.entity.name
            })
          }
        })
      }

      return entities
    },
    entityOptions: function () {
      return this.createClustersAndEntitiesList(this.clusters, this.readableEntities)
    },
    userOptions: function () {
      if (this.selectedEntityIds.length) {
        return this.usersFromEntityActivities.filter(user => user.activities.some(activity => this.selectedEntityIds.includes(activity.entity_id)))
      } else {
        return this.usersFromEntityActivities
      }
    },
    ...mapState({
      infoTypes(state, getters) {
        return getters[`${this.waitingRoomModuleKey}/infoTypes`]
      },
      accessTypes(state, getters) {
        return getters[`${this.waitingRoomModuleKey}/accessTypes`]
      }
    }),
    waitingRoomModuleKey: function () {
      return `virtualWaitingRoom`
    },
    virtualWaitingRoomService: function () {
      return this.$store.state.services.find(s => s.url === this.$store.state.virtual_waiting_room_server)
    },
    isSupervisor: function () {
      return this.virtualWaitingRoomService.user_permissions.some(permission => permission.info_type === this.infoTypes.REQUESTS && permission.access_type >= this.accessTypes.ADMIN)
    },
  },
  data: function () {
    return {
      originalData: [],
      filters: {
        entities: [],
        dispensers: [],
        dateRange: {
          start: this.moment().startOf('month').format('YYYY-MM-DD'),
          end: this.moment().endOf('month').format('YYYY-MM-DD')
        },
        appointmentTypes: []
      },
      selectedEntityIds: [],
      selectedEntityUids: [],
      entityActivityRecordsForPeriod: [],
      isLoading: true,
      isRequestingData: false,
      showDownloadExcelModal: false
    }
  },
  created: function () {
    this.loadAuthUserEntityActivityRecords()
  },
  methods: {
    ...mapActions('auth', {
      loadAuthUserEntityActivityRecords: 'LOAD_AUTH_USER_ENTITY_ACTIVITIES'
    }),
    exportExcelClosed: function () {
      this.showDownloadExcelModal = false
    },
    loadEntityActivityUsersForPeriod: function () {
      return new Promise((resolve, reject) => {
        let params = {
          accessType: WriteAccessType,
          infoType: DispenserStatisticsInfoType,
          serviceId: this.component.service.id,
          start: this.moment(this.filters.dateRange.start).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
          end: this.moment(this.filters.dateRange.end).endOf('day').format('YYYY-MM-DD HH:mm:ss'),
          activities: `${DispenserFieldActivityId},${DispenserOnPremisesActivityId}`
        }
        ActivityService.getActivityUsersByEntity(params)
          .then(entityActivityRecords => {
            this.entityActivityRecordsForPeriod = entityActivityRecords
            resolve()
          }).catch(errors => {
          console.log('errors', errors)
          reject(errors)
        })
      })
    },
    loadLocalStorage: function () {
      return new Promise((resolve, reject) => {
        let state = LocalStorageHelper.get(WAITING_ROOM_DISPENSER_STATISTICS)

        if (state !== null) {
          if (state.hasOwnProperty('start') && state.start !== null) {
            this.filters.dateRange.start = state.start
          }

          if (state.hasOwnProperty('end') && state.end !== null) {
            this.filters.dateRange.end = state.end
          }

          if(state.appointmentTypes && state.appointmentTypes !== '') {
            const filteredIds = state.appointmentTypes.split(',').map(id => parseInt(id))
            this.filters.appointmentTypes = this.appointmentTypesOptions.filter(elem => elem.bdIds.some(id => filteredIds.includes(id)))
          }

          this.loadEntityActivityUsersForPeriod()
            .finally(() => {
              if (Array.isArray(state.selectedEntityUids) && state.selectedEntityUids) {
                this.filters.entities = this.reloadSelectedClustersAndEntities(this.entityOptions, state.selectedEntityUids)
              }

              if (state.hasOwnProperty('dispensers') && state.dispensers !== null && state.dispensers !== '') {
                if (this.userOptions.length) {
                  let userIds = state.dispensers.split(',').map(id => parseInt(id))
                  this.filters.dispensers = this.userOptions.filter(u => userIds.includes(u.id))
                }
              }

              this.$nextTick(() => {
                this.hasLoadedLocalStorage = true
                resolve()
              })
            })
        } else {
          this.loadEntityActivityUsersForPeriod()
            .finally(() => {
              this.$nextTick(() => {
                this.hasLoadedLocalStorage = true
                resolve()
              })
            })
        }
      })
    },
    getActiveFilters: function () {
      return {
        start: _get(this.filters, 'dateRange.start', null) || undefined,
        end: _get(this.filters, 'dateRange.end', null) || undefined,
        ...this.filters.dispensers.length && { dispensers: this.filters.dispensers.map(user => user.id).join(',') },
        ...this.filters.entities.length && { entities: this.filters.entities.map(entity => entity.id).join(',') },
        isRequesteeSupervisor: this.isSupervisor,
        appointmentTypes: this.filters.appointmentTypes.flatMap(type => type.bdIds).join(',')
      }
    },
    getLocalStorageFilters: function () {
      return {
        ...this.getActiveFilters(),
        dispensers: this.filters.dispensers.length > 0 ? this.filters.dispensers.map(u => u.id).join(',') : '',
        selectedEntityUids: this.selectedEntityUids,
        appointmentTypes: this.filters.appointmentTypes.flatMap(type => type.bdIds).join(',')
      }
    },
    getStatistics: function () {
      return new Promise((resolve, reject) => {
        StatisticsService.getDispenserStatistics(this.component.service.url, this.getActiveFilters())
          .then(data => {
            this.originalData = data
            resolve()
          })
          .catch(errors => {
            console.log(errors)
            this.showToast(this.$t('clinical.waiting_room_statistics.something_went_wrong'), this.$store.state.errorToastOptions)
            reject(errors)
          })
      })
    },
    onInputUsers: function () {
      this.getStatistics()
        .then(() => {
          this.isRequestingData = false
        })
    }
  },
  watch: {
    userOptions: function (newValue) {
      if (this.filters.dispensers.some(user => !newValue.some(userOption => userOption.id === user.id))) {
        this.filters.dispensers = this.filters.dispensers.filter(user => newValue.some(userOption => userOption.id === user.id))
      }
    },
    'filters.dateRange': {
      handler: function () {
        if (this.hasLoadedLocalStorage) {
          this.isRequestingData = true
          this.loadEntityActivityUsersForPeriod()
          this.getStatistics()
            .then(() => {
              this.isRequestingData = false
            })
        }
      },
      deep: true
    },
    'filters.dispensers': function (value) {
      if (this.hasLoadedLocalStorage) {
        this.isRequestingData = true
        this.getStatistics()
          .then(() => {
            this.isRequestingData = false
          })
      }
    },
    'filters.entities': function (options) {
      const selectedOptions = this.getSelectedOptionsIdsAndUids(options)
      this.selectedEntityIds = selectedOptions.ids
      this.selectedEntityUids = selectedOptions.uids
      this.isRequestingData = true
      this.getStatistics()
        .then(() => {
          this.isRequestingData = false
        })
    },
    'filters.appointmentTypes': function (options) {
      this.getStatistics()
        .then(() => {
          this.isRequestingData = false
        })
    },
    'filters': {
      handler: function () {
        LocalStorageHelper.set(WAITING_ROOM_DISPENSER_STATISTICS, this.getLocalStorageFilters())
      },
      deep: true
    },
    'hasLoadedAuthUserEntityActivities': {
      handler: function (hasLoaded) {
        if (hasLoaded) {
          this.loadLocalStorage()
            .then(() => this.getStatistics())
            .then(() => {
              this.isLoading = false
            })
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">
#user-statistics {
  .kpi-card {
    min-height: 12rem;
  }
}
</style>
